'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionPictureInPictureAlt = function ActionPictureInPictureAlt(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 11h-8v6h8v-6zm4 8V4.98C23 3.88 22.1 3 21 3H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H3V4.97h18v14.05z' })
  );
};
ActionPictureInPictureAlt = (0, _pure2.default)(ActionPictureInPictureAlt);
ActionPictureInPictureAlt.displayName = 'ActionPictureInPictureAlt';
ActionPictureInPictureAlt.muiName = 'SvgIcon';

exports.default = ActionPictureInPictureAlt;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/action/picture-in-picture-alt.js
 ** module id = 1544
 ** module chunks = 0
 **/